const initialState = {

    thaiOrOtherNation: "thai",
    citizenOrPassport: "passport",
    citizenId: null,
    passportNumber: null,
    email: null,

};

import { getField, updateField } from 'vuex-map-fields';

export const createAccount = {
    namespaced: true,
    state: initialState,
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
};